import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://znuobpdaaskrkeqmcjwy.supabase.co';
const supabaseKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpudW9icGRhYXNrcmtlcW1jand5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzQwNTk1NDMsImV4cCI6MTk4OTYzNTU0M30.zIwSF3TnywTiyCchd-skzJpVZPmNasNo_2Ik4KYS8pc';
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
